const isSioyie = typeof window !== 'undefined' && window.location.hostname.includes('sioyie.com');
const isAgentMode = typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('mode') === 'agent';

export const generateDefaultModels = () => {
  const models = [];


  if (isSioyie) {
    models.push({
      id: 'default',
      name: 'Default RainseeAi',
      type: 'text',
      endpoint: 'https://api.rainsee.cn/v1/chat/completions',
      apiKey: 'sk-aabaaaaaaaa',
      model: 'rainsee-turbo'
    });
    models.push({
      id: 'default-t2i',
      name: 'Default RainseeAi Image',
      type: 't2i',
      endpoint: 'https://api.rainsee.cn/v1/chat/completions',
      apiKey: 'sk-aabaaaaaaaa',
      model: 'rainsee-turbo'
    });
    models.push({
      id: 'default-i2i',
      name: 'Default RainseeAi I2I',
      type: 'i2i',
      endpoint: 'https://api.rainsee.cn/v1/chat/completions',
      apiKey: 'sk-aabaaaaaaaa',
      model: 'rainsee-turbo'
    });
  }
  return models;
};

export const generateActiveModelIds = () => {
  return {
    activeModelId: (isSioyie || isAgentMode) ? 'default' : '', // Legacy / Current fallback
    activeTextModelId: (isSioyie || isAgentMode) ? 'default' : '',
    activeT2iModelId: isSioyie ? 'default-t2i' : '',
    activeI2iModelId: isSioyie ? 'default-i2i' : '',
  };
};
